import React from "react";
import Nav from "../nav/Nav";
import { useEffect } from "react";


function ArtificialIntelligence() {
   
useEffect(() => {
  const cards = document.querySelectorAll('.flip-card');

  const handlers = [];

  cards.forEach(card => {

    const toggle = () => {
      // Close all other cards
      cards.forEach(c => {
        if (c !== card) {
          c.classList.remove('is-flipped');
          c.setAttribute('aria-pressed', 'false');
        }
      });

      // Toggle current card
      const isFlipped = card.classList.toggle('is-flipped');
      card.setAttribute('aria-pressed', isFlipped ? 'true' : 'false');
    };

    const btn = card.querySelector('.flip-btn');
    const hint = card.querySelector('.flip-hint');
    const backBtn = card.querySelector('.flip-back-btn');

    if (btn) {
      btn.addEventListener('click', toggle);
      handlers.push({ el: btn, fn: toggle });
    }

    if (hint) {
      hint.addEventListener('click', toggle);
      handlers.push({ el: hint, fn: toggle });
    }

    if (backBtn) {
      backBtn.addEventListener('click', toggle);
      handlers.push({ el: backBtn, fn: toggle });
    }

    const keyHandler = (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggle();
      }
    };

    card.addEventListener('keydown', keyHandler);
    handlers.push({ el: card, fn: keyHandler });
  });

  // ✅ Cleanup to prevent memory leaks
  return () => {
    handlers.forEach(({ el, fn }) => {
      el.removeEventListener('click', fn);
      el.removeEventListener('keydown', fn);
    });
  };

}, []); 
  return (
    <>
      <div>
        <style
          dangerouslySetInnerHTML={{
            __html:
              "\n        .flip-card {\n            perspective: 1000px;\n            height: 180px;\n            /* card height */\n        }\n\n        .flip-inner {\n            position: relative;\n            width: 100%;\n            height: 100%;\n            transition: transform .6s;\n            transform-style: preserve-3d;\n        }\n\n        .flip-card.is-flipped .flip-inner {\n            transform: rotateY(180deg);\n        }\n\n        .flip-face {\n            position: absolute;\n            inset: 0;\n            backface-visibility: hidden;\n            border-radius: .75rem;\n            overflow: hidden;\n        }\n\n        .flip-front {\n            background: var(--bs-light);\n            border: 1px solid var(--bs-border-color);\n            display: grid;\n            place-items: center;\n            padding: 1rem;\n        }\n\n        .flip-back {\n            transform: rotateY(180deg);\n            background: var(--bs-dark);\n            color: #fff;\n            border: 1px solid var(--bs-border-color);\n            padding: 1rem 1.1rem;\n            display: grid;\n            align-content: center;\n        }\n\n        .flip-title {\n            font-weight: 700;\n            letter-spacing: .2px;\n        }\n\n        .flip-btn {\n            all: unset;\n            cursor: pointer;\n            display: inline-flex;\n            align-items: center;\n            justify-content: center;\n            gap: .5rem;\n            padding: .9rem 1.1rem;\n            /* border-radius: .75rem; */\n            /* background: var(--bs-primary); */\n            color: #fff;\n            font-weight: 600;\n            width: 100%;\n            text-align: center;\n        }\n\n        .flip-hint {\n            font-size: .8rem;\n            opacity: .8;\n        }\n\n        #section2 {\n            background: linear-gradient(90deg, rgb(1, 10, 24) 0%, rgb(4, 35, 56) 100%);\n        }\n\n       \n    ",
          }}
        />
        <div className="sub-banner-section-outer position-relative">
          <header>
            <Nav />
          </header>
          {/* SUB-BANNER SECTION */}
          <section className="banner-section position-relative">
            <div className="container">
              <div className="row">
                <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                  <div className="banner-section-content">
                    <h1 className="text-white">GazTec AI Modeling</h1>
                    <p className="text-white">
                      AI-driven solutions to outsmart evolving cyber threats
                      with speed and Precision
                    </p>
                    <div className="btn_wrapper">
                      <span> Home </span>
                      <i
                        className="fa-solid fa-angles-right"
                        aria-hidden="true"
                      />
                      <span className="sub_span">GazTec AI Modeling</span>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                  <div className="banner_image position-relative">
                    <figure className="banner_main_image mb-0 left_right_shape">
                      <img
                        src="./assets/images/ai.png"
                        alt
                        width="100%"
                        className="img-fluid"
                      />
                    </figure>
                    <figure className="banner_image_bottom_shape mb-0 position-absolute top_bottom_shape">
                      <img
                        src="./assets/images/sub_banner_image_bottom_shape.png"
                        alt
                        className="img-fluid"
                      />
                    </figure>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <figure className="banner_top_shape mb-0 position-absolute top_bottom_shape">
            <img
              src="./assets/images/sub_banner_top_shape.png"
              alt
              className="img-fluid"
            />
          </figure>
          <figure className="banner_background_shape mb-0 position-absolute left_right_shape">
            <img src="./assets/images/sub_banner_background_shape.png" alt />
          </figure>
          <a href="#section2" className="position-absolute down-arrow">
            <i
              className="fa-solid fa-chevron-down fa-bounce"
              style={{ color: "#5cc9ff" }}
            />
          </a>
        </div>
        {/* PRODUCT SECTION */}
        <section
          className="services_section position-relative section position-relative"
          style={{ padding: "100px 0" }}
        >
          <div className="container align-items-center h-100">
            <div className="row position-relative" style={{ zIndex: 1000 }}>
              {/*  */}
              {/* <div class="col-12 col-lg-5">

              <div class="hover-effect" data-aos="fade-down">

                  <figure>

                      <img src="./assets/images/heavy.png" alt="" class="img-fluid hover-effect">

                  </figure>

              </div>

          </div> */}
              <div className="col-12">
                <div className="statistics_content mb-5 mt-0 pt-0 text-white">
                  <h2 className="mb-3 text-center">
                    Cybercrime Never Sleeps, and Neither
                  </h2>
                  <div className="container">
                    <div className="row">
                      <div
                        className="col-md-6 text-light bg-info p-3 m-3"
                        style={{ borderRadius: 15, height: "fit-content" }}
                      >
                        <h4>Unmatched Speed:</h4>
                        <p>
                          Gaztec AI modeling processes vast amounts of data in
                          real-time, detecting threats like ransomware or
                          insider attacks before they strike—faster than any
                          human could.
                        </p>
                      </div>
                      <div
                        className="col-md-5 text-light bg-info p-3 m-3"
                        style={{ borderRadius: 15, height: "fit-content" }}
                      >
                        <h4>Adaptive Intelligence:</h4>
                        <p>
                          Our AI solutions learn your unique environment,
                          adapting to new threats like zero-day exploits or
                          sophisticated phishing campaigns with precision.
                        </p>
                      </div>
                    </div>
                    <div className="row">
                      <div
                        className="col-md-6 text-light bg-info p-3 m-3"
                        style={{ borderRadius: 15, height: "fit-content" }}
                      >
                        <h4>Proactive Defense:</h4>
                        <p>
                          Gaztec AI modeling provides predictive analytics to
                          anticipate vulnerabilities, enabling preemptive action
                          to secure your systems before attackers even know
                          where to strike.
                        </p>
                      </div>
                      <div
                        className="col-md-5 text-light bg-info p-3 m-3"
                        style={{ borderRadius: 15, height: "fit-content" }}
                      >
                        <h4>Automated Response:</h4>
                        <p>
                          From isolating compromised devices to blocking
                          malicious traffic, Gaztec AI modeling automates
                          responses, minimizing damage and freeing your team to
                          focus on strategy.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <figure className="services_background_shape mb-0 position-absolute left_right_shape">
                <img
                  src="./assets/images/services_background_shape.png"
                  alt
                  className="img-fluid"
                />
              </figure>
            </div>
          </div>
          <figure className="services_right_shape mb-0 position-absolute top_bottom_shape">
            <img
              src="./assets/images/services_right_shape.png"
              alt
              className="img-fluid"
            />
          </figure>
        </section>
        <section id="section2" className=" text-light aos-init ">
          <div className="container-fluid py-5 aos-animate">
            <div className="text-center mb-4">
              <h1 className="h3 mb-2">AI Security Stack</h1>
              <span className="text-secondary mb-0">
                Click a product to flip and reveal its description
              </span>
            </div>
            <div className="row d-flex justify-content-center">
              {/* Darktrace Antigena */}
              <div
                className="col-md-3 col-lg-3 mb-4 bg-info text-light m-1 p-2 pt-5"
                style={{ borderRadius: 15, height: "fit-content" }}
              >
                <div className="flip-card" tabIndex={0} role="button">
                  <div className="flip-inner">
                    <div className="flip-face flip-front">
                      <button className="flip-btn">Darktrace Antigena</button>
                      <div className="flip-hint text-secondary text-light">
                        Click to view description
                      </div>
                    </div>
                    <div className="flip-face flip-back flip-back-btn">
                      <div>
                        {/* <h6 class="font-weight-bold">Darktrace Antigena</h6> */}
                        <p>
                          Using self-learning AI, Darktrace creates a dynamic
                          "pattern of life" for your network, detecting and
                          neutralizing anomalies like crypto-mining or data
                          exfiltration in real-time. Proven to stop attacks, as
                          seen at CordenPharma, where it blocked 1GB of
                          malicious data transfers.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* CrowdStrike Falcon */}
              <div
                className="col-md-3 col-lg-3 mb-4 bg-info text-light m-1 p-2 pt-5"
                style={{ borderRadius: 15, height: "fit-content" }}
              >
                <div className="flip-card" tabIndex={0} role="button">
                  <div className="flip-inner">
                    <div className="flip-face flip-front">
                      <button className="flip-btn">CrowdStrike Falcon</button>
                      <div className="flip-hint text-secondary mt-2 text-light">
                        Click to view description
                      </div>
                    </div>
                    <div className="flip-face flip-back flip-back-btn">
                      <div>
                        {/* <h6 class="font-weight-bold">CrowdStrike Falcon</h6> */}
                        <p>
                          This AI-powered endpoint protection platform uses
                          machine learning for threat hunting and behavioral
                          attack prevention, safeguarding laptops and servers
                          from ransomware and advanced persistent threats.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Microsoft Security Copilot */}
              <div
                className="col-md-3 col-lg-3 mb-4 bg-info text-light m-1 p-2 pt-5"
                style={{ borderRadius: 15, height: "fit-content" }}
              >
                <div className="flip-card" tabIndex={0} role="button">
                  <div className="flip-inner">
                    <div className="flip-face flip-front">
                      <button className="flip-btn">
                        Microsoft Security Copilot
                      </button>
                      <div className="flip-hint text-secondary mt-2 text-light">
                        Click to view description
                      </div>
                    </div>
                    <div className="flip-face flip-back flip-back-btn">
                      <div>
                        {/* <h6 class="font-weight-bold">Microsoft Security Copilot</h6> */}
                        <p>
                          Leveraging generative AI, this tool analyzes vast
                          datasets and automates incident response workflows,
                          empowering your team to prioritize and resolve threats
                          efficiently within Microsoft ecosystems.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Vectra AI Cognito */}
              <div
                className="col-md-3 col-lg-3 mb-4 bg-info text-light m-1 p-2 pt-5"
                style={{ borderRadius: 15, height: "fit-content" }}
              >
                <div className="flip-card" tabIndex={0} role="button">
                  <div className="flip-inner">
                    <div className="flip-face flip-front">
                      <button className="flip-btn">Vectra AI Cognito</button>
                      <div className="flip-hint text-secondary mt-2 text-light">
                        Click to view description
                      </div>
                    </div>
                    <div className="flip-face flip-back flip-back-btn">
                      <div>
                        {/* <h6 class="font-weight-bold">Vectra AI Cognito</h6> */}
                        <p>
                          A network detection and response platform that uses AI
                          to analyze traffic and prioritize threats like lateral
                          movement, reducing false positives for your security
                          operations.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Tessian */}
              <div
                className="col-md-3 col-lg-3 mb-4 bg-info text-light m-1 p-2 pt-5"
                style={{ borderRadius: 15, height: "fit-content" }}
              >
                <div className="flip-card" tabIndex={0} role="button">
                  <div className="flip-inner">
                    <div className="flip-face flip-front">
                      <button className="flip-btn">Tessian</button>
                      <div className="flip-hint text-secondary mt-2 text-light">
                        Click to view description
                      </div>
                    </div>
                    <div className="flip-face flip-back flip-back-btn">
                      <div>
                        {/* <h6 class="font-weight-bold">Tessian</h6> */}
                        <p>
                          This AI-driven email security platform prevents
                          phishing, account takeovers, and data loss by
                          analyzing email patterns, protecting your inbox from
                          threats.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* CONTACT MAP SECTION */}
        <div className="contact_map_section">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d462561.6574537445!2d55.22748795!3d25.076022449999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f43496ad9c645%3A0xbde66e5084295162!2sDubai%20-%20United%20Arab%20Emirates!5e0!3m2!1sen!2sin!4v1699347606733!5m2!1sen!2sin"
                width="100%"
                height={450}
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ArtificialIntelligence;
